/*
 * Module for viewing and changing categories
 */

define([
  "marionette",
  "backbone",
  "messaging/messenger",
  "./categoriesView",
  "./categoryList/categoryListModule",
  "./category/categoryModule",
  "modules/header/kbMenu/kbMenuModel",
], function (
  Marionette,
  Backbone,
  Messenger,
  CategoryView,
  CategoryListModule,
  CategoryModule,
  KbMenuModel,
) {
  var CategoriesModule = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "Categories";
      this.region = options.region;
      this._setUpReqRes();
      this._setUpVents();
    },
    show: function () {
      //get the property (probably not synced!)
      this.categories = Messenger.reqres.request("fetch:kb:categories");
      this.languagesWithDefault = Messenger.reqres.request("kb:languagesWithDefault");
      this.attributes = Messenger.reqres.request("kb:attributes");
      this.selectedLanguage = null;
      Messenger.onSave(function () {
        console.log("saving categories configuration");
        this.categories.saveCollection();
      }, this);

      this.attributes.onSynced(function () {
        this.categories.onSynced(function () {
          this.languagesWithDefault.onSynced(function () {
            this.selectedLanguage = this.languagesWithDefault.first();
            this.categories.languagesWithDefault = this.languagesWithDefault;
            this.categories.selectedLanguage = this.selectedLanguage;
            this.layout = new CategoryView.categoriesView({ model: this.categories });

            this.category = this.addSubModule(new CategoryModule({ region: this.layout.category }));
            this.categoryList = this.addSubModule(
              new CategoryListModule({
                region: this.layout.categoryList,
                nameAttribute: "categoryName",
              }),
            );

            this.layout.on(
              "add:category",
              function () {
                Messenger.save(function (success) {
                  if (success) {
                    var newCategory = this.categories.addCategory();
                    this.categoryList.selectItem(newCategory);
                  }
                }, this);
              },
              this,
            );

            this.layout.on(
              "change:selectedLanguageId",
              function (languageId) {
                var language = this.languagesWithDefault.findWhere({
                  id: languageId,
                });
                this.selectedLanguage = language;
                this.categories.selectedLanguage = this.selectedLanguage;
                Messenger.vent.trigger("change:kb:selected:language", language);
                Messenger.vent.trigger("change:kb:selected:language:info", language);
              },
              this,
            );

            Messenger.vent.on(
              "delete:category",
              function (model) {
                model.deleteModel(); //deleting the model triggers the selectable list to no longer consider this model selected
              },
              this,
            );

            this.showRegion(this.layout, { loading: false });
            this._showSubViews();
          }, this);
        }, this);
      }, this);
    },
    _showSubViews: function () {
      this.categoryList.show(this.categories);
    },
    _setUpReqRes: function () {
      Messenger.reqres.setHandler(
        "kb:selected:language",
        function () {
          return this.selectedLanguage;
        },
        this,
      );
    },
    _setUpVents: function () {
      //Show the categories admin screen
      Messenger.vent.on(
        "show:authoring:admin:categories",
        function () {
          const kbId = Messenger.reqres.request("active:kb");
          Backbone.history.navigate(kbId + "/authoringAdmin/categories");
          this.show();
        },
        this,
      );
      //show the module
      Messenger.vent.on(
        "show:kb:admin:categories",
        function () {
          const kbId = Messenger.reqres.request("active:kb");
          Backbone.history.navigate(kbId + "/authoringAdmin/categories");
          this.show();
        },
        this,
      );
    },
  });

  return CategoriesModule;
});
